import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  margin-left: -130px;
  width: 358px;
  max-height: 250px;
  padding: 16px 4px 0 4px;
  border: 1px solid #d8dae5;
  border-radius: 8px;
  box-shadow: 0px 12px 28px rgba(33, 39, 73, 0.2);
  z-index: 10;
  background-color: #fff;
  overflow-y: auto;
  overflow-x: hidden;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
    position: fixed;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Item = styled.button`
  display: flex;
  width: 100%;
  flex-direction: column;
  border: 0;
  border-radius: 8px;
  background-color: transparent;
  padding: 8px 16px;

  transition: 0.2s;

  :hover {
    background-color: #f6f8ff;
  }
`;

export const Label = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1b203a;
  text-align: left;
`;

export const Description = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #474d66;
  text-align: left;

  margin-top: 4px;
`;

export const Text = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #474d66;
  padding: 24px 16px 24px 16px;
`;

export const TextButton = styled.a`
  font-weight: 500;
  font-size: 12px;
  color: #1371fe;
`;
